import React from "react";
import LaturMap from "../Comp/laturmap/LaturMap";
import SearchComp from "../Comp/search/SearchComp";
import Flipbook from "../Comp/flip/Flipbook.jsx";
import TwoColSec from "../Comp/twocol/TwoColSec.js";
import img from ".././assets/arvindpatil.png";
import Header from "../Comp/header/Header.js";
import Footer from "../Comp/footer/Footer.js";
import Hero from "../Comp/newhero/Hero.js";
import Mani from "../Comp/Mani/Mani.js";
import Pdf from "../Comp/flip/pdf/Pdf.js";
import Test from "../Comp/test/Test.js";
import Videos from "../Comp/video/Videos.js";
import Letter from "../Comp/letter/Letter.js";
import New_letter from "../Comp/letter/New_letter.js";
import Song_video from "../Comp/songs-video/Song_video.js";
import Interview_video from "../Comp/interview-video/Interview_video.js";
import Video_sec from "../Comp/video-section/Video_sec.js";
import Photo_gallery from "../Comp/photo-gallery/Photo_gallery.js";

function ElectionPage() {
  return (
    <>
      {/* <Header /> */}

      {/* <Hero/> */}
      {/* <TwoColSec
        bg={img}
        subheading="सर्वांना हेवा वाटेल असा मतदारसंघ घडवूया!"
        subdescription={`प्रिया मतदार बंधू आणि भगिनींनो,<br/>
लोकप्रतिनिधी म्हणून आपण सर्वांनी दिलेल्या संधींचे सोने करून आपला मतदारसंघ आणि आपल्या सर्वांच्या जीवनात होईल तितका विकासात्मक बदल घडविण्याचा प्रामाणिक प्रयत्न केला आहे. आज आपल्या मतदारसंघात प्रत्येक गावात आणि गावातील प्रत्येक उंबरठ्यात विकास पोहोचला आहे. रस्त्यांचे जाळे, सुदृढ आरोग्य व्यवस्था, घरपोच पिण्याचे पाणी, शेतकरी व महिला भगिनींसाठी असलेल्या सर्व योजनांची प्रभावी अंमलबजावणी यामुळे मतदारसंघ विकासाच्या यात्रेत अत्यंत वेगाने पुढे जात आहे. ज्याचा लेखाजोखा आपल्या समोर वेळोवेळी मांडलेला आहे. आता वेळ आहे या विकासाचा पुढील टप्पा साध्य करण्याचा. आधुनिक जगासोबत स्पर्धा करणारा शाश्वत व भविष्यवेधी विकास साधण्यासाठी पुन्हा एकदा आपल्या आशीर्वादांची गरज असून आपले प्रेम व आशीर्वाद निरंतर सोबत राहू द्या. आपल्या आशीर्वादाने संपूर्ण जगाला हेवा वाटेल असा मतदारसंघ मिळून घडवूया!`}
      /> */}
      <SearchComp />
      <LaturMap />
      <Mani /> 
      <Pdf />
      <Videos />
      <New_letter />

      <Song_video />
      <Interview_video />
      <Photo_gallery />
       <Footer />

      {/* <Test/> */}
      {/* <Flipbook /> */}
      
    </>
  );
}

export default ElectionPage;
